import React from 'react';

const InputCardItems = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className='mt-3 flex items-center gap-1 text-[14px] font-light'>
      {children}
    </div>
  );
};

export default InputCardItems;
